import { computed } from 'vue';
import { useCurrentUserQuery, UserType } from '@/generated/graphql';

export const useCurrentUser = () => {
	const { result, loading } = useCurrentUserQuery({
		fetchPolicy: 'cache-first',
	});

	const currentUser = computed(() => result.value?.CurrentUser);

	const isCUPOUser = computed(
		() => currentUser.value?.type === UserType.Cupo
	);

	const isAdmin = computed(() => currentUser.value?.type === UserType.Admin);

	const permissionSetName = computed(
		() => currentUser.value?.permissionSet?.name
	);

	return {
		loading,
		currentUser,
		isCUPOUser,
		isAdmin,
		permissionSetName,
	};
};
